import { useTranslation } from 'react-i18next';
import { Modal } from '~/components/overlays';
import { ContactForm } from '~/components/common/ContactForm';
import type { ContactRowData } from './contactModalState';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  organizationId: string;
  contact: ContactRowData | null;
  isOwnOrganization: boolean;
};

export default function ContactModal({
  isOpen,
  onClose,
  organizationId,
  contact,
  isOwnOrganization,
}: Props) {
  const { t } = useTranslation('organizations');

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-neut-bg-alt rounded-lg p-6 w-full max-w-md">
        <h2 id="Modal-title" className="text-base font-semibold text-neut-prim">
          {contact
            ? t('organizations.contact.editTitle')
            : t('organizations.contact.addTitle')}
        </h2>
        <p className="text-xs text-neut-sec mt-0.5 mb-4">
          {t('organizations.contact.subtitle')}
        </p>
        <ContactForm
          organizationId={organizationId}
          audience={isOwnOrganization ? 'own' : 'tradingPartner'}
          contact={contact}
          onCancel={onClose}
          onSaved={onClose}
        />
      </div>
    </Modal>
  );
}
